import {
  FETCH_VEHICLE_BODYTYPES_DATA,
  FETCH_VEHICLE_BODYTYPES_SUCCESS,
  FETCH_VEHICLE_BODYTYPES_FAILURE,
  FETCH_VEHICLE_BODYTYPES_EDIT_DATA,
  FETCH_VEHICLE_BODYTYPES_EDIT_SUCCESS,
  FETCH_VEHICLE_BODYTYPES_EDIT_FAILURE,
} from "./actionTypes";

export const fetchVehiclesBodyTypesData = () => ({
  type: FETCH_VEHICLE_BODYTYPES_DATA,
});

export const fetchVehiclesBodyTypesSuccess = (data) => ({
  type: FETCH_VEHICLE_BODYTYPES_SUCCESS,
  payload: data,
});

export const fetchVehiclesBodyTypesFailure = (error) => ({
  type: FETCH_VEHICLE_BODYTYPES_FAILURE,
  payload: error,
});

export const fetchVehiclesBodyTypesEditData = (id) => ({
  type: FETCH_VEHICLE_BODYTYPES_EDIT_DATA,
  payload: id,
});

export const fetchVehiclesBodyTypesEditSuccess = (data) => ({
  type: FETCH_VEHICLE_BODYTYPES_EDIT_SUCCESS,
  payload: data,
});

export const fetchVehiclesBodyTypesEditFailure = (error) => ({
  type: FETCH_VEHICLE_BODYTYPES_EDIT_FAILURE,
  payload: error,
});
